module.exports = __webpack_public_path__ + "img/google_download.fa510ad1.png";